const updatesData = [
  { date: '2026-07-31', tag: '上新', title: '《封神第二部》高清版全网首发上线', hot: true },
  { date: '2026-07-30', tag: '热播', title: '《乘风破浪的姐姐》第五季最新期更新', hot: true },
  { date: '2026-07-29', tag: '专题', title: '暑期档观影指南专题页面上线，一站导航', hot: false },
  { date: '2026-07-28', tag: '优化', title: '播放器升级至V4.2版本，画质与加载速度双提升', hot: false },
  { date: '2026-07-27', tag: '上新', title: '《庆余年第二季》全36集一次性上线', hot: true },
  { date: '2026-07-26', tag: '公告', title: '新增"我的片单"功能，收藏追剧更方便', hot: false },
  { date: '2026-07-25', tag: '上新', title: '2026最新日漫新番合集同步上线', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">最新动态</h2>
          <p className="text-foreground-400 text-sm">平台内容更新与功能升级，不错过每一个精彩</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/40 space-y-6">
            {updatesData.map((item, i) => (
              <div key={i} className="relative group">
                <div className={`absolute -left-[41px] w-3.5 h-3.5 rounded-full border-2 ${
                  item.hot ? 'bg-accent-500 border-accent-500' : 'bg-background-200 border-background-400'
                }`}></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap w-fit ${
                    item.tag === '上新' ? 'bg-primary-500/15 text-primary-400 border border-primary-500/25' :
                    item.tag === '热播' ? 'bg-accent-500/15 text-accent-400 border border-accent-500/25' :
                    item.tag === '优化' ? 'bg-secondary-500/15 text-secondary-400 border border-secondary-500/25' :
                    'bg-background-300/50 text-foreground-400 border border-background-400/30'
                  }`}>{item.tag}</span>
                  <span className="text-sm text-foreground-200 font-medium">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}